import { IconContainerMessage, IconChatCx, IconChatUser, IconTimeChat, IconCallChat } from '../../../assets/icons/index';
import React from 'react';
import { CSSProps } from '@twilio/flex-ui-core/src/components/CSSProps';
import { TranslationUtils, ValidationUtils } from '../../../utils';
import { ChatChannelState } from '@twilio/flex-webchat-ui';
import moment from 'moment';
import '../WebChat.scss';

interface WelcomeMessageProps {
    container?: CSSProps;
    icon?: CSSProps;
    isOpen: boolean;
    availableTimes: {
        localTimeToOpen: string;
        localTimeToClose: string;
    };
}

export const ContainerMessage: React.FC<WelcomeMessageProps> = ({ isOpen, availableTimes }): JSX.Element => {
    const tollFreePhone = ValidationUtils.validateAndGetEnvVar('REACT_APP_TOLL_FREE_PHONE_NUMBER');
    return (
        <div id={'mainContainer'} className={'Font Font-Container ContainerMessage'}>
            <span id={'icon'}>
                <IconContainerMessage />
            </span>
            {isOpen ? (
                <span id={'openMessage'}>
                    {TranslationUtils.get('chat_open')}
                    <br />
                    {TranslationUtils.get('chat_rule', {
                        openTime: availableTimes.localTimeToOpen,
                        closeTime: availableTimes.localTimeToClose,
                    })}
                </span>
            ) : (
                <span id={'closeMessage'} className={'Close-Message'}>
                    <span id={'messageField'} className={'Message-Rule'}>
                        {TranslationUtils.get('chat_message_close', {
                            openTime: availableTimes.localTimeToOpen,
                            closeTime: availableTimes.localTimeToClose,
                        })}
                    </span>
                    <span id={'timeField'} className={'Icon-Close'}>
                        <IconTimeChat />
                        {TranslationUtils.get('chat_rule_close', {
                            openTime: availableTimes.localTimeToOpen,
                            closeTime: availableTimes.localTimeToClose,
                        })}
                    </span>
                    <span id={'phoneField'} className={'Icon-Close'}>
                        <IconCallChat />
                        <a href={`tel: ${tollFreePhone}`}>{tollFreePhone}</a>
                    </span>
                </span>
            )}
        </div>
    );
};

export const ChatLoading: React.FC<{ text: string }> = (props): JSX.Element => {
    const { text } = props;
    return (
        <div id={'chatLoading'} className={'Font Font-Loading Flex-Loader'}>
            <p>{text}</p>
        </div>
    );
};

interface MessageBubbleProps {
    message?: ChatChannelState.MessageState;
    member?: ChatChannelState.MemberState;
}

export const MessageBubble: React.FC<MessageBubbleProps> = ({ member, message }) => {
    const fromMe: boolean = 'Guest' == member?.friendlyName;
    const nameCx: string | undefined =
        member?.friendlyName.split(' ').length == 2 ? member?.friendlyName.split(' ')[0] : member?.friendlyName;
    const time: string | undefined = message && moment(message?.source.timestamp).format('hh:mm A');

    return (
        <div className={'Main-Bubble'}>
            {!fromMe && (
                <span className={'Icon-Left'}>
                    <IconChatCx />
                </span>
            )}
            <div className={!fromMe ? 'Messagebubble-Left' : 'Messagebubble-Right'}>
                <div className={'Font'}>
                    <span className={'Font-Name HeaderBubble-Name'}>{fromMe ? TranslationUtils.get('chat_me') : nameCx}</span>
                    <span className={`${!fromMe ? 'Font-Time HeaderBubble-Time-Left' : 'Font-Time HeaderBubble-Time-Right'}`}>{time}</span>
                </div>
                <div className={'Font-Message BodyBubble'}>{message?.source.body}</div>
            </div>
            {fromMe && (
                <span className={'Icon-Right'}>
                    <IconChatUser />
                </span>
            )}
        </div>
    );
};
